import { DefaultTheme } from 'styled-components'

const Theme: DefaultTheme = {
  colors: {
    background: "#0D1111",
    foreground: "#F4F4F4",
    foreground_low: "#D6D6D6",
    over_black: "#C8C8C8",
    over_white: "#454545",
    foreground_lower: "#8D8D8D",
    foreground_lowest: "#4F4F4F",
    accent: "#1A4CE0",
    accent_smalltext: "#4871EA",
    white: "#F4F4F4",
    warning: "#F2C53A",
    error: "#CC2E44",
    success: "#27AE60",
    success_background: "#27ae6012",
  },
  stroke: "1px",
};

export default Theme;